import React, { useContext } from "react";
import SideBar from "components/common/SideBar/SideBarNew";
import Header from "components/common/Header/Header";
import PermissionDenied from "components/common/404Permission/404Permission";
import { LoginContext } from "helpers/LoginContext";
import { useVertex360CopilotAccess } from "components/Vertex360Copilot/hooks/useVertex360CopilotAccess";
import { Vertex360CopilotWorkspaceProvider } from "components/Vertex360Copilot/hooks/useVertex360CopilotWorkspace";
import Vertex360CopilotWorkspaceLayout from "components/Vertex360Copilot/workspace/Vertex360CopilotWorkspaceLayout";
import "components/Vertex360Copilot/vertex360Copilot.css";

const Vertex360CopilotPage = () => {
  const { sideBarPadding } = useContext(LoginContext);
  const canUseCopilot = useVertex360CopilotAccess();

  if (!canUseCopilot) {
    return <PermissionDenied />;
  }

  return (
    <div className="min-h-screen bg-[#F6F7F8]">
      <SideBar />
      <div
        className={`${sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
          } flex min-h-screen flex-col`}
      >
        <Header title="Vertex360 Copilot" desc="Organisation's AI assistant" />

        <section className="container mx-auto flex min-h-0 flex-1 flex-col px-2 pb-6 pt-3 sm:px-4 lg:px-5 copilot-workspace-page">
          <Vertex360CopilotWorkspaceProvider>
            <Vertex360CopilotWorkspaceLayout />
          </Vertex360CopilotWorkspaceProvider>
        </section>
      </div>
    </div>
  );
};

export default Vertex360CopilotPage;
